// tmpUuidを除いたオブジェクトキー取得
export const getImageKey = imageKey => {
  const dataKey = JSON.parse(JSON.stringify(imageKey))
  // スラッシュで分けて、末尾を削除
  const splitDataKey = dataKey.split('/')
  splitDataKey.pop()
  // 末尾以外をスラッシュで連結する
  return splitDataKey.join('/')
}

export const getImageAttrs = image => {
  const width = Math.floor(String(image.width).replace('px', '')) + 'px'
  const height = Math.floor(String(image.height).replace('px', '')) + 'px'
  return {
    width,
    height,
    'data-width': width,
    'data-height': height,
    'data-key': image.key,
    'data-image-key': getImageKey(image.key),
    'data-filename': image.filename,
    'data-external-url': image['data-external-url'],
    src: image.url,
    alt: image.alt
  }
}

export const getMultiplePrivateBucketUrl = () => {
  // 指定する環境変数依存なので、どちらでも対応できるように
  // region ありなしのプライベートバケットURLを返す
  // https://mailscat-dev-private.s3.amazonaws.com
  // https://mailscat-dev-private.s3-ap-northeast-1.amazonaws.com
  const bucketUrl = process.env.VUE_APP_S3_PRIVATE_URL
  const bucket = process.env.VUE_APP_S3_PRIVATE_BUCKET
  const region = 'ap-northeast-1'

  const regex = new RegExp(region)
  const anotherBucketUrl = bucketUrl.match(regex) ? `https://${bucket}.s3.amazonaws.com` : `https://${bucket}.s3-${region}.amazonaws.com`
  return [bucketUrl, anotherBucketUrl]
}

export const getImageDisplayRatio = partsContainer => {
  let imageDisplayRatio = 1 / 2
  switch (partsContainer.horizontal_display_ratio) {
    case 'imageOneToTextOne':
      imageDisplayRatio = 1 / 2
      break
    case 'imageTwoToTextOne':
      imageDisplayRatio = 2 / 3
      break
    case 'imageOneToTextTwo':
      imageDisplayRatio = 1 / 3
      break
    case 'imageOneToTextThree':
      imageDisplayRatio = 1 / 4
      break
    default:
      break
  }
  return imageDisplayRatio
}
